import { render } from "./gui.vue?vue&type=template&id=4523a3ec&scoped=true"
import script from "./gui.vue?vue&type=script&lang=js"
export * from "./gui.vue?vue&type=script&lang=js"

import "./gui.vue?vue&type=style&index=0&id=4523a3ec&scoped=true&lang=css"

import exportComponent from "E:\\lb\\vue30\\tuiguang_meng\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4523a3ec"]])

export default __exports__